import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import { grey } from '@mui/material/colors';

function Copyright() {
  return (
    <Typography variant="body2" sx={{color:'white'}}>
      {'Copyright © '}
      <Link color="inherit" target="_blank" href="https://msanp.gov.mg">
        MSANP
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
const defaultTheme = createTheme();

export default function Footer() {
  return (
    <ThemeProvider theme={defaultTheme}>
        <CssBaseline />
        <Box
          component="footer"
          sx={{
            py: 1,
            px: 2,
            mt: 'auto',
            backgroundColor: grey[500]
          }}
        >
          <Container maxWidth="sm" sx={{textAlign:'center',color:'white'}}>
            <Typography variant="body1">
              <b>Ministeran’ny fahasalamam-bahoaka</b>
            </Typography>
            <Copyright />
          </Container>
        </Box>
    </ThemeProvider>
  );
}